import { ValidationResult } from '@classifieds-sell/datalayer';
import {
    StepDisabledStates,
    StepModel,
    StepTouchedStates,
    StepValidityStates
} from '@classifieds-sell/shared';
import { StepIds } from '../models/property-step/property-step-model';

export const updatePropertySteps = (
    currentPropertySteps: StepModel[],
    validationResults: ValidationResult[]
): StepModel[] => {
    if (validationResults === null) {
        return currentPropertySteps;
    }
    let enableNextStep = false;

    const updatedSteps = currentPropertySteps.map((propertyStep) => {
        const index = validationResults.findIndex(
            (v) => v.stepId === propertyStep.stepId
        );

        if (index !== -1 && validationResults[index].isValid !== null) {
            const updatedStep = {
                ...propertyStep,
                disabledState: StepDisabledStates.enabled,
                validity:
                    validationResults[index].isValid === true
                        ? StepValidityStates.valid
                        : StepValidityStates.invalid,
                touchedState: StepTouchedStates.touched
            } as StepModel;
            // If the step is valid, enable the next step
            enableNextStep = validationResults[index].isValid === true;
            return updatedStep;
        }
        // Enable the next step if the previous step was valid
        if (enableNextStep) {
            enableNextStep = false;
            return {
                ...propertyStep,
                disabledState: StepDisabledStates.enabled
            } as StepModel;
        }

        return propertyStep;
    });

    return updatedSteps;
};

export const isStepEnabled = (
    currentPropertySteps: StepModel[],
    currentStepId: StepIds
): boolean => {
    return currentPropertySteps.some(
        (s) =>
            s.stepId === currentStepId &&
            s.disabledState === StepDisabledStates.enabled
    );
};

export const getAdjacentSteps = (
    currentPropertySteps: StepModel[],
    currentStepId: StepIds
): string[] => {
    const currentStepIndex = currentPropertySteps.findIndex(
        (s) => s.stepId === currentStepId
    );

    let prevStepId: string = null;
    let nextStepId: string = null;

    if (currentStepIndex > 0) {
        prevStepId = currentPropertySteps[currentStepIndex - 1].stepId;
    }

    if (currentStepIndex < currentPropertySteps.length - 1) {
        nextStepId = currentPropertySteps[currentStepIndex + 1].stepId;
    }

    return [prevStepId, nextStepId];
};
